import { render, staticRenderFns } from "./RewardCheck.vue?vue&type=template&id=197b079d&scoped=true"
import script from "./RewardCheck.vue?vue&type=script&lang=js"
export * from "./RewardCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b079d",
  null
  
)

export default component.exports